export default "__VITE_ASSET__CjhIit9L__"